module.exports = __webpack_public_path__ + "static/media/spark-capital.96011143.png";